/**
 * PublicLanding — the public homepage entry. Fetches the ACTIVE landing design;
 * if it's "classic" (default), render the original Landing page untouched, so
 * switching designs is zero-risk. Otherwise render the block-based design.
 */
import React, { useEffect, useState } from 'react';
import Landing from './Landing';
import { LandingRenderer } from '../components/landing/LandingRenderer';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

export default function PublicLanding() {
  const [state, setState] = useState({ loading: true, design: null, id: 'classic' });

  useEffect(() => {
    let ok = true;
    fetch(`${API_BASE}/api/landing/active`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (!ok) return;
        if (d && d.design && !d.design.is_classic) {
          setState({ loading: false, design: d.design, id: d.active_design_id });
        } else {
          setState({ loading: false, design: null, id: 'classic' });
        }
      })
      .catch(() => { if (ok) setState({ loading: false, design: null, id: 'classic' }); });
    return () => { ok = false; };
  }, []);

  // While deciding, render the classic page so there's never a blank flash for
  // the default case (the overwhelmingly common one).
  if (state.loading || !state.design) return <Landing />;
  return <LandingRenderer design={state.design} />;
}
